import React from "react"
import { useParams } from "react-router"

import { useActiveOrganizationId } from "@/contexts"
import { isAdminEntityUnavailable } from "@/modules/admin/utils/is-admin-entity-unavailable"
import { isUnavailableMeterError, useMeter } from "@/services/meter"
import { parseModelId } from "@/utils/parse-model-id"

export const useAdminMeterPageState = () => {
  const { activeOrganizationId } = useActiveOrganizationId()
  const { meterId: meterIdParam } = useParams()

  const meterId = parseModelId(meterIdParam)
  const organizationId = activeOrganizationId ?? ""

  const {
    meterData,
    meterError,
    meterIsFetched,
    meterIsFetching,
    meterIsLoading,
    ...meterQueryResult
  } = useMeter({
    meterId: meterId === undefined ? null : String(meterId),
    organizationId,
    queryOptions: {
      enabled: Boolean(organizationId) && meterId !== undefined,
    },
  })

  const meterBelongsToAnotherOrganization = React.useMemo(() => {
    const meterSiteOrganizationId = meterData?.site?.organizationId
    if (!meterIsFetched || meterSiteOrganizationId === undefined) {
      return false
    }

    return String(meterSiteOrganizationId) !== organizationId
  }, [meterData?.site?.organizationId, meterIsFetched, organizationId])

  const meterIsUnavailable =
    meterBelongsToAnotherOrganization ||
    isAdminEntityUnavailable({
      data: meterData,
      error: meterError,
      id: meterId,
      isFetched: meterIsFetched,
      isUnavailableError: isUnavailableMeterError,
    })

  return {
    ...meterQueryResult,
    meterData,
    meterError,
    meterId,
    meterIsFetched,
    meterIsFetching,
    meterIsLoading,
    meterIsUnavailable,
  }
}
